/** ignore */
export const attrListRegExp = /[;,\s]/g;
/** ignore */
export const joinWith = (name: string) => (name === 'class' || name.indexOf('aria') >= 0 ? ' ' : ',');
